<template lang="html">

  <VqModal
    :name="modalName"
    :can-close='false'>
    <template v-slot:header>
      <h2 class="modal-title">{{ $t('components.modalCgu.title') }}</h2>
      <button
        v-if="alreadyAccepted"
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
      <div class="forms">
        <div class="container has-separator">
          <Loader v-if="isDataLoading"/>

          <div v-html="cgu" class="wysiwyg-cgu" />
            <!-- I have read and agreed with <a :href="download" target='_blank' class="pointer is-warning"> the terms and conditions</a> -->
          <!-- </div> -->
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div v-if="!alreadyAccepted" class="flex is-justified-between w-full">
        <button type="button" class="button is-small is-gray-400" v-on:click="logout">{{ $t('components.modalCgu.decline') }}</button>
        <button type="button" class="button is-small is-gamma" @click="submit">{{ $t('components.modalCgu.agree') }}</button>
      </div>
      <button v-else type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalCgu.close') }}</button>

    </template>
  </VqModal>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';
import CGU from '@/api/cgu';
import Loader from '@/components/Loader.vue';


import VqModal from '@/components/VqModal.vue';

export default {
  name: 'ModalCgu',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    Loader,
  },
  props: [],

  data() {
    return {
      modalName: 'modal-cgu',
      alreadyAccepted: false,
      errors: {},
      cgu: '',
      isDataLoading: true,
    };
  },

  mounted() {
    this.eventHub.$on(`modal:${this.modalName}:open`, (data) => {
      if (data == 'already-accepted') {
        this.alreadyAccepted = true;
      }
    });

    this.getCgu();
  },

  computed: {
    // download() {
    //   return CGU.download()
    // },
  },

  methods: {
    getCgu() {
      CGU.get().then((res) => {
        this.cgu = res.data.cgu;
        this.isDataLoading = false;
      },
      (err) => {
        Object.assign(this.errors, err.response.data);
      });
    },

    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.replace({ name: 'login', params: { locale: this.$i18n.locale } });
      });
    },

    close() {
      this.eventHub.$emit(`modal:${this.modalName}:close`);
    },

    submit() {
      CGU.post().then(
        (res) => {
          this.close();
        },
        (err) => {
          Object.assign(this.errors, err.response.data);
        },
      );
    },
  },
};
</script>


<style lang="scss">

.wysiwyg-cgu strong {
  font-weight: bold;
}
.wysiwyg-cgu {
  max-height: 400px;
  overflow: scroll;
  font-size: 14px;
  line-height: 1.3;


  p {
    margin-bottom: 10px;
  }

  h1 {
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 10px;
  }

  h2 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 10px;
    margin-top: 15px;
  }
  h3 {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
    margin-top: 15px;
   }
  em {
    font-style: italic;
   }
  ul {
    list-style: inside;
    padding-left: 30px;
    li {
      margin-bottom: 10px;
      list-style-type: round;
    }
  }
 }
</style>
